/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_PaperplaneiconInputs */

const en_enum_custom_page_icon_paperplaneicon = /** @type {(inputs: Enum_Custom_Page_Icon_PaperplaneiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paperplane`)
};

const de_enum_custom_page_icon_paperplaneicon = /** @type {(inputs: Enum_Custom_Page_Icon_PaperplaneiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papierflugzeug`)
};

/**
* | output |
* | --- |
* | "Paperplane" |
*
* @param {Enum_Custom_Page_Icon_PaperplaneiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_paperplaneicon = /** @type {((inputs?: Enum_Custom_Page_Icon_PaperplaneiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_PaperplaneiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_paperplaneicon(inputs)
	return de_enum_custom_page_icon_paperplaneicon(inputs)
});